<template>
    <div>

        <tq-on-top-container >
            <div slot="body" class="TQ_inline">
                <slot></slot>
            </div>

            <div slot="middle" class="TQ_inline" v-if="p_showBeacon_b" >
                <div class="TQ_animation_beacon TQ_bg_circle TQ_inline TQ_padding_2px" >
                </div>
            </div>

        </tq-on-top-container>


    </div>
</template>

<script>
    import TqOnTopContainer from "../basic/TqOnTopContainer";
    import TqPopup from "../basic/TqPopup";
    export default {
        name: "TqBeacon",
        components: {TqPopup, TqOnTopContainer},
        props:{
            p_showBeacon_b : {
                require: true,
                type: Boolean
            },

        },
    }
</script>

<style scoped lang="scss">




</style>